// Function to calculate the height of the element
function calculateImageHeight() {
    var imageContainers = document.querySelectorAll('.text-with-image-slider-container');

    imageContainers.forEach(function (imageContainer) {
        var imageHeight = imageContainer.querySelector('.text-with-image-item__image').clientHeight;

        var nextButton = imageContainer.querySelector('.swiper-button-next');
        var prevButton = imageContainer.querySelector('.swiper-button-prev');
        var pagination = imageContainer.querySelector('.swiper-pagination');

        nextButton.style.top = imageHeight + 'px';
        prevButton.style.top = imageHeight + 'px';
        pagination.style.top = imageHeight + 14 + 'px';
    });
}

window.addEventListener('load', calculateImageHeight);
window.addEventListener('resize', calculateImageHeight);
